/**
 * @generated SignedSource<<e5efdcab25beb2a7145d1fc4828c421c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleDateContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"defaultArticleDateContent" | "plusArticleDateContent">;
  readonly " $fragmentType": "articleDateContent";
};
export type articleDateContent$key = {
  readonly " $data"?: articleDateContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleDateContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleDateContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "plusArticleDateContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "defaultArticleDateContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "3cdb12d679f5146e2c0918860b065212";

export default node;
